import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import BusMaintenanceStayForm from './BusMaintenanceStayForm';
import { postBusMaintenanceStay } from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';
import { tzNormalizeDate } from '../../../../utils/date';

const NewBusMaintenanceStay = ({
  breadcrumbs,
  dispatchPostBusMaintenanceStay,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    newFormValues.registeredBusId = formValues.registeredBusId.value;
    newFormValues.originCityId = formValues.originCityId.value;
    newFormValues.estimatedArrivalDate = formValues.estimatedArrivalDate
      ? tzNormalizeDate({ date: formValues.estimatedArrivalDate })
      : null;
    dispatchPostBusMaintenanceStay(newFormValues);
  };

  const content = <BusMaintenanceStayForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Estancia de Mantenimiento por Bus"
      subtitle="Crear nueva estancia de mantenimiento por bus"
      content={content}
    />
  );
};

NewBusMaintenanceStay.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBusMaintenanceStay: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostBusMaintenanceStay: postBusMaintenanceStay,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Estancias de Mantenimiento por Bus',
      href: BUS_MAINTENANCE_STAY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewBusMaintenanceStay);
